// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Loader2 } from "lucide-react";

/**
 * Simple inline loader for smaller sections (tables, cards, etc.)
 * Use this for loading states within page content
 *
 * Usage:
 * {loading && <InlineLoader />}
 * {loading && <InlineLoader size="sm" />}
 */
const InlineLoader = ({ size = "md", message = null }) => {
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  const containerPadding = {
    sm: "py-2",
    md: "py-4",
    lg: "py-6",
  };

  return (
    <div
      className={`flex items-center justify-center ${containerPadding[size]}`}
    >
      <div className="text-center">
        <Loader2
          className={`${sizeClasses[size]} text-blue-600 animate-spin mx-auto`}
        />
        {message && <p className="text-gray-600 text-sm mt-2">{message}</p>}
      </div>
    </div>
  );
};

export default InlineLoader;
